import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./modules/main/main.module').then(m => m.MainModule),
  },
  {
    path: 'applink',
    children: [
      {
        path: 'control',
        children: [
          { path: 'dashboard', redirectTo: '/control', pathMatch: 'prefix' },
          { path: 'scenarios', redirectTo: '/control', pathMatch: 'prefix' }, // TODO: create page to download app
          { path: 'schedules', redirectTo: '/control', pathMatch: 'prefix' }, // TODO: create page to download app
          { path: 'automations', redirectTo: '/control', pathMatch: 'prefix' }, // TODO: create page to download app or add automations in webapp ?
        ],
      },
      {
        path: 'energy',
        children: [
          { path: 'dashboard', redirectTo: '/control', pathMatch: 'prefix' },
          { path: 'schedules', redirectTo: '/settings/planning', pathMatch: 'prefix' },
          { path: 'heatings/graph', redirectTo: '/control', pathMatch: 'prefix' },
          { path: 'settings/autoadapt', redirectTo: '/control', pathMatch: 'prefix' }, // TODO: create page to download app
          { path: 'settings/operating-mode', redirectTo: '/control', pathMatch: 'prefix' }, // TODO: create page to download app
        ],
      },
      {
        path: 'security',
        children: [
          { path: 'dashboard', redirectTo: '/security', pathMatch: 'prefix' },
          { path: 'timeline', redirectTo: '/security', pathMatch: 'prefix' },
          { path: 'settings/alert-and-recording', redirectTo: '/security', pathMatch: 'prefix' }, // TODO: create page to download app
        ],
      },
      {
        path: 'weather',
        children: [
          { path: 'dashboard', redirectTo: '/control', pathMatch: 'prefix' },
        ],
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { anchorScrolling: 'enabled' })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
